import { get } from 'lodash'
import { connect } from 'react-redux'

import { auth } from '../../../../constants/actions'
import withRecaptcha from '../../../../hoc/withRecaptcha'
import ForgotPassword from './component'

export const mapStateToProps = state => ({
  eventLogo: get(state, 'formSettings.eventLogo'),
  orgLogo: get(state, 'formSettings.orgLogo'),
  landingPageLogo: get(state, 'formSettings.landingPageLogo'),
  formType: get(state, 'formSettings.formType'),
  isSubmitPending: get(state, 'common.showLoadingIndicator'),
  forgotPasswordMsg: get(state, 'auth.forgotPasswordMsg.message'),
  landingPageImage: get(state, 'formSettings.landingPageImage'),
  bgGradientPrimaryColor: get(state, 'formSettings.bgGradientPrimaryColor'),
  bgGradientSecondaryColor: get(state, 'formSettings.bgGradientSecondaryColor'),
})

export default connect(mapStateToProps, {
  forgotPassword: auth.forgotPassword,
  resendVerificationEmail: auth.resendVerificationEmail,
  setForgotPasswordMsg: auth.setForgotPasswordMsg,
})(withRecaptcha('ForgotPassword')(ForgotPassword))
